export default "__VITE_ASSET__6ac6dfc5__"